import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import TR from './../Trans';

const initialState = {
  isEnvironmentSet: false,
  environment: null
}

const environmentStore = create((set, get) => ({
  ...initialState,
  reset: () => { 
    set(initialState)
  },
  getEnvironment: (sessionToken) => {
MuvikaService.getEnvironment(sessionToken, TR.getLanguage())
      .then(function (res) {
        if (res.data.error) {
          set({ isEnvironmentSet: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ isEnvironmentSet: true, environment: res.data.data });
        }
      })
      .catch(function(){});
  },
}));

export default environmentStore;